import { useState, useEffect } from 'react';
import { SubscriptionData } from '../types';
import { useSubscriptionStatus } from './billingHooks';
import { useAuth } from '../components/auth/AuthProvider';

function useSubscription() {
  const { currentUser } = useAuth();
  const [subscription, setSubscription] = useState<SubscriptionData | null>(
    null,
  );
  const [error, setError] = useState<string | null>(null);

  const { data, isLoading, isError, refetch } = useSubscriptionStatus(
    Boolean(currentUser),
  );

  useEffect(() => {
    if (data) {
      const subData = data as any;
      setSubscription(subData);
      setError(null);
    }
  }, [data]);

  useEffect(() => {
    if (isError) {
      setError('Failed to load subscription');
    }
  }, [isError]);

  const current = ((data as any) ?? subscription) as SubscriptionData | null;
  const isPremium = Boolean(
    current?.subscription_status === 'active' && current?.plan === 'premium',
  );

  return {
    sub: subscription,
    loading: isLoading,
    error,
    isPremium,
    refetch: refetch,
  };
}

export default useSubscription;
